import { useState } from "react";
import noUserImage from "../../../assets/image/noUserImage.png";
const TeamCard = ({ description, designation, image, name }) => {
  const [flipped, setFlipped] = useState(false);

  const handleToggle = () => setFlipped((prev) => !prev);

  return (
    <div
      className="relative h-96 perspective cursor-pointer"
      onClick={handleToggle}
      onMouseEnter={() => window.innerWidth > 768 && setFlipped(true)}
      onMouseLeave={() => window.innerWidth > 768 && setFlipped(false)}
    >
      <div
        className={`relative w-full h-full rounded-2xl transform-style preserve-3d transition-transform duration-[1200ms] ease-[cubic-bezier(0.25,0.1,0.25,1)] ${
          flipped ? "rotate-y-180 scale-105" : "scale-100"
        } shadow-[rgba(0,0,0,0.2)_0px_30px_60px_-12px,rgba(0,0,0,0.25)_0px_18px_36px_-18px] border border-white/10 hover:border-white/20`}
      >
        <div
          className={`absolute w-full h-full backface-hidden bg-gradient-to-br from-teal-700 via-teal-800 to-teal-900 text-white rounded-2xl overflow-hidden transition-opacity duration-700 ease-in ${
            flipped ? "opacity-0" : "opacity-100"
          }`}
        >
          <img
            src={image || noUserImage}
            alt={name}
            className="w-full h-4/5 object-cover"
          />
          <div className="p-4 text-center">
            <h3 className="text-lg font-semibold">{name}</h3>
            <p className="text-sm opacity-70">{designation}</p>
          </div>
        </div>

        <div
          className={`absolute w-full h-full backface-hidden rotate-y-180 bg-gradient-to-br from-slate-300 via-teal-500 to-slate-400 text-white rounded-2xl p-4 flex flex-col justify-center transition-opacity duration-700 ease-in ${
            flipped ? "opacity-100" : "opacity-0"
          }`}
        >
          <div className="bg-black/30 backdrop-blur-sm rounded-xl p-4 shadow-inner">
            <h3 className="text-lg font-bold mb-2 text-white">{name}</h3>
            <p className="text-sm text-white/80 mb-2">{designation}</p>
            {/* <div className="relative group max-w-full text-sm text-white/90 leading-relaxed">
              {description?.length > 50 ? (
                <>
                  <p className="truncate">{description}</p>
                  <span className="text-xs text-teal-200 underline cursor-pointer relative group">
                    Read more
                    <div className="absolute z-50 top-full left-1/2 -translate-x-1/2 mt-2 hidden group-hover:block bg-black/90 text-white text-xs px-4 py-2 rounded-xl shadow-xl w-72 leading-snug">
                      {description}
                    </div>
                  </span>
                </>
              ) : (
                <p>{description}</p>
              )}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamCard;
